import { bl_inv_opdg_element_RowClass } from '../../dbschema';
import { BaseContainerModel } from '../base-container.model';

export class InventoryOpdgElementContainerModel extends BaseContainerModel {
  bl_inv_opdg_element: bl_inv_opdg_element_RowClass = new bl_inv_opdg_element_RowClass();
}
